//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters, mapMutations } from "vuex";
import { date } from "quasar";
import DataModelModal from "@/pages/main/views/Reports/DataModelModal/DataModelModal.vue";
import FabricSearch from "@/components/q-fabric-search.vue";
import UserList from "@/components/tasks/userList/userList.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AddEditGroupMembers from "@/components/Admin/RolesAndUsers/AddEditGroupMembers/add-edit-group-members.vue";
import { formatDateAndTime } from "@/components/Diagrams/config/set-conditions";
import { APP_DATE_SLASH, APP_DATETIME_SLASH } from "@/assets/js/appConfig";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import tabComponents from "./mixins/tab-components";

export default {
    components: {
        DataModelModal,
        AQBadge,
        FabricSearch,
        UserList,
        AddEditGroupMembers,
        AQButton,
        AQCheckbox,
        AQTooltip,
        AQInput,
        AQToggle,
        AQCard
    },
    filters: {},
    mixins: [tabComponents],
    props: {
        mode: {
            type: String,
            default: "a", // a - admin(ProcessInspector), b - diagram/rule testing (RuleTesting)
            validator: v => ["a", "b"].includes(v.toLowerCase())
        },
        getObjectToSend: {
            type: Object,
            default: () => {}
        },
        searchData: {
            type: String,
            default: ""
        },
        appToSelect: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            dateFormat: APP_DATETIME_SLASH,
            processList: [],
            archivedProcessList: [],
            selectedProcesses: [],
            selectedArchivedProcesses: [],
            pagedAppsObjectCopy: null,
            currentApplicationsArray: [],
            selected: [],
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            selfOrigin: { vertical: "top", horizontal: "left" },
            addDataModelModal: false,
            isInEditMode: false,
            indexDataModel: null,
            dataModelList: [],
            editDataModel: {},
            editDataModelIndex: null,
            dataModel: [],
            selectedApp: [],
            searchTerm: "",
            searchApp: "",
            systemStatus: [],
            appsSelectedArray: [],
            sortField: "modifiedOn",
            nrOfFilters: 0,
            nrOfResults: 0,
            noFromStartDateFound: false,
            noToStartDateFound: false,
            toStartIsBigger: false,
            noFromLastUpdateFound: false,
            noToLastUpdateFound: false,
            toLastIsBigger: false,
            selectedTab: "users",
            searchRoleUsers: "",
            searchUsersGroups: "",
            searchUsers: "",
            searchTrigger: false,
            showClearIconFromStart: true,
            showClearIconToStart: true,
            showClearIconFromLast: true,
            showClearIconToLast: true,
            userCheck: [],
            groupsCheck: [],
            initiatorCheck: [],
            userFilteredList: [],
            rolesFilteredList: [],
            fromStartDate: "",
            toStartDate: "",
            fromLastUpdate: "",
            toLastUpdate: "",
            showAppList: false,
            checkboxDisabled: false,
            processToggleDisabled: false,
            firstLoadApps: true,
            openOrCloseCollaps: [
                {
                    icon: "mdi-chevron-down",
                    handler: () => {
                        this.openOrCloseAppList();
                    }
                }
            ],
            objToSend: {
                page: 0,
                searchTerm: "",
                size: 10,
                sortDirection: "DESC",
                sortField: "modifiedOn",
                applicationIds: [],
                processDefinitionIds: [],
                systemStatuses: []
            },
            dataSystemStatus: [
                {
                    label: this.$t("admin.processInspector.allStatuses"),
                    value: "ALL_STS"
                },
                {
                    label: this.$t("admin.processInspector.runningStatus"),
                    value: "RUNNING"
                },
                {
                    label: this.$t("admin.processInspector.completedStatus"),
                    value: "COMPLETED"
                },
                {
                    label: this.$t("admin.processInspector.failedStatus"),
                    value: "FAILED"
                },
                {
                    label: this.$t("admin.processInspector.terminateStatus"),
                    value: "TERMINATED"
                },
                {
                    label: this.$t("admin.processInspector.archivedStatus"),
                    value: "ARCHIVED"

                }
            ],
            selectedValues: [],
            selectedInitiators: [],
            allGroupMembersIds: [],
            pagedAppsObject: {
                page: 0,
                search: "",
                ids: [],
                archived: false
            },
            archivedApp: false,
            archivedProcess: false,
            selectedAppsDetails: [],
            myLocaleRo: {
                days: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                daysShort: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                months: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                monthsShort: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                firstDayOfWeek: 1
            },
            objFromQueryURL: null,
            searchValueUserList: "",
            searchValueGroupMembers: "",
            initiatorUserFromUrlToShow: false,
            hasAssigneesSelected: false,
            assigneeMembers: [],
            deactivatedTriggered: false,
            mountedApplyFilter: false
        };
    },
    computed: {
        ...mapGetters("rules", ["showInstanceTable"]),
        ...mapGetters("apps", ["apps", "pagedApps", "hasMoreApps", "allAppsNumber", "getStaticAppIdsList"]),
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("reports", ["getDataModelFilter"]),
        ...mapGetters("admin", ["roleList", "userList", "getGroupsListApp"]),
        ...mapGetters("userProfile", ["userDataDetails"]),
        searchAction() {
            let appliedFilters = true;
            const findAllStatuses = this.systemStatus.find(el => (el === "ALL_STS"));
            if (findAllStatuses && this.nrOfFilters === 5) {
                appliedFilters = false;
            } else {
                appliedFilters = !!this.nrOfFilters;
            }
            return !!this.searchTerm || appliedFilters;
        },
        myLocale() {
            let localeToReturn = null;
            if (this.userDataDetails && this.userDataDetails.language === "ro") {
                localeToReturn = this.myLocaleRo;
            }
            return localeToReturn;
        },
        setToStartdateProps() {
            return {
                options: this.optionsToStartDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        },
        setToLastdateProps() {
            return {
                options: this.optionsToLastDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        },
        filterAssigneeList() {
            let applicationId;
            if (this.appsSelectedArray.length && this.appsSelectedArray.length === 1) {
                applicationId = this.appsSelectedArray[0].value;
            }
            return applicationId ? { applicationId } : null;
        },

        errorLabelStart() {
            let result = "";
            if (this.noFromStartDateFound) {
                result = this.$t("admin.processInspector.errorFromDate");
            } else if (this.noToStartDateFound) {
                result = this.$t("admin.processInspector.errorDate");
            } else if (this.toStartIsBigger) {
                result = this.$t("admin.processInspector.errorToStartBigger");
            }
            return result;
        },
        getErrorIsBigger() {
            return this.toLastIsBigger ? this.$t("admin.processInspector.errorToLastBigger") : "";
        },
        filterUserGroupsList() {
            return this.userFilteredList
                .filter(user => (
                    (user.email
                            && user.email
                                .toLowerCase()
                                .includes(
                                    this.searchUsersGroups.toLowerCase()
                                ))
                        || (user.firstName
                            && user.firstName
                                .toLowerCase()
                                .includes(
                                    this.searchUsersGroups.toLowerCase()
                                ))
                        || (user.lastName
                            && user.lastName
                                .toLowerCase()
                                .includes(this.searchUsersGroups.toLowerCase()))
                ))
                .sort((a, b) => {
                    const nameA = a.firstName
                        ? a.firstName.toLowerCase()
                        : a.firstName;
                    const nameB = b.firstName
                        ? b.firstName.toLowerCase()
                        : b.firstName;
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                });
        },
        filteredUserList() {
            return this.userFilteredList
                .filter(user => (
                    (user.email
                            && user.email
                                .toLowerCase()
                                .includes(
                                    this.searchRoleUsers.toLowerCase()
                                ))
                        || (user.firstName
                            && user.firstName
                                .toLowerCase()
                                .includes(
                                    this.searchRoleUsers.toLowerCase()
                                ))
                        || (user.lastName
                            && user.lastName
                                .toLowerCase()
                                .includes(this.searchRoleUsers.toLowerCase()))
                ))
                .sort((a, b) => {
                    const nameA = a.firstName
                        ? a.firstName.toLowerCase()
                        : a.firstName;
                    const nameB = b.firstName
                        ? b.firstName.toLowerCase()
                        : b.firstName;
                    if (nameA < nameB) return -1;
                    if (nameA > nameB) return 1;
                    return 0;
                });
        },
        filteredRoleList() {
            return this.rolesFilteredList.filter(role => role.name
                .toLowerCase()
                .includes(this.searchUsersGroups.toLowerCase()));
        },
        anchor() {
            return `${this.anchorOrigin.vertical} ${this.anchorOrigin.horizontal}`;
        },
        self() {
            return `${this.selfOrigin.vertical} ${this.selfOrigin.horizontal}`;
        }
    },
    watch: {
        selectedValues: {
            handler() {
                this.userCheck = [];
                this.groupsCheck = [];
                if (this.selectedValues.length) {
                    for (let i = 0; i < this.selectedValues.length; i++) {
                        if (this.selectedValues[i].type === "USER") {
                            this.userCheck.push(this.selectedValues[i].id);
                        } else {
                            this.groupsCheck.push(this.selectedValues[i].id);
                        }
                    }
                }
            }
        },
        showInstanceTable: {
            handler(newVal) {
                if (newVal && this.mode === "b") {
                    this.clearAll("resetFilters");
                    const resetPayload = {
                        page: 0,
                        searchTerm: "",
                        size: 10,
                        sortDirection: "DESC",
                        sortField: "modifiedOn",
                        applicationIds: this
                            .currentApplicationsArray,
                        processDefinitionIds: [],
                        systemStatuses: this.systemStatus
                    };
                    this.$emit("applyFilterPayload", resetPayload);
                }
            }
        },
        getObjectToSend: {
            handler(newVal) {
                if (newVal && (newVal.status || newVal.direction)) {
                    this.applyFilter(newVal.status, newVal.direction, newVal.rowsPerPage, newVal.page);
                }
            }
        },
        searchData: {
            handler(newValue) {
                this.searchTerm = newValue;
                this.$root.$emit("searchResult", this.searchTerm);
                this.applyFilter();
            }
        },
        roleList: {
            handler(newValue) {
                this.rolesFilteredList = newValue || [];
            },
            immediate: true
        },
        userList: {
            handler(newValue) {
                this.userFilteredList = newValue || [];
            },
            immediate: true
        },
        fromStartDate: {
            handler(value) {
                this.showClearIconFunc(value, "fromStartDate");
            }
        },
        toStartDate: {
            handler(value) {
                this.showClearIconFunc(value, "toStartDate");
                if (value && this.fromStartDate) {
                    this.toStartIsBigger = this.checkDate(this.fromStartDate, value);
                } else {
                    this.toStartIsBigger = false;
                }
            }
        },
        fromLastUpdate: {
            handler(value) {
                this.showClearIconFunc(value, "fromLastUpdate");
            }
        },
        toLastUpdate: {
            handler(value) {
                this.showClearIconFunc(value, "toLastUpdate");
                if (value && this.fromLastUpdate) {
                    this.toLastIsBigger = this.checkDate(this.fromLastUpdate, value);
                } else {
                    this.toLastIsBigger = false;
                }
            }
        },
        getDataModelFilter: {
            handler(val) {
                if (val.fieldType === "TIME" || val.fieldType === "DATE" || val.fieldType === "DATETIME") {
                    val.statementInput = val.value;
                    val.value = formatDateAndTime(val.fieldType.toLowerCase(), val.value).replace(/'/g, "");
                }
                if (this.isInEditMode) {
                    this.dataModelList.splice(this.editDataModelIndex, 1, val);
                    this.dataModel[this.indexDataModel] = val;
                } else {
                    this.dataModelList.push(val);
                }
            }
        },
        value: {
            handler(val) {
                if (val) {
                    this.showAppList = !!this.selectedApp.length;
                }
            },
            immediate: true
        }
    },
    created() {
        this.nrOfResults = 0;
    },
    mounted() {
        this.getAppsNumber();

        this.currentApplicationsArray.push(
            this.getCurrentApplicationId
        );
        if (this.mode === "a" && this.$route.query && !Object.keys(this.$route.query).length) {
            this.mountedApplyFilter = true;
            this.objToSend.systemStatuses = ["FAILED"];
            this.systemStatus = ["FAILED"];
            this.$emit("applyFilterPayload", this.objToSend);
        }
        if (this.appToSelect) {
            this.selectedApp.push(this.appToSelect.id);
            this.selectApp(this.selectedApp);
            this.applyFiltersBtn();
        }
    },
    activated() {
        const { query } = this.$route;
        const queryToLoad = {};

        Object.entries(query).forEach(([key, value]) => {
            if (this.objToSend.hasOwnProperty(key)) {
                queryToLoad[key] = Array.isArray(this.objToSend[key])
                    ? value.split(",")
                    : value;
            }
        });

        this.objFromQueryURL = { ...queryToLoad };

        if (query && Object.keys(query).length) {
            if (query.applicationIds) {
                this.displayAppList();
                this.archivedApp = query.archivedApp.toLowerCase() === "true";
                this.archivedProcess = query.archivedProcesses.toLowerCase() === "true";
                const appsData = [...this.objFromQueryURL.applicationIds];
                this.selectApp(appsData);
                if (appsData.length > 0) {
                    this.selectedApp = appsData;
                }
            }
            if (query.processDefinitionIds) {
                const processesFromUrl = query.processDefinitionIds.split(",");
                const appIdForProcesses = this.objFromQueryURL.applicationIds.slice(-1)[0];
                this.getAppProcessesPI({ appId: appIdForProcesses, archived: this.archivedProcess }).then(rsp => {
                    if (rsp.data) {
                        rsp.data.forEach(item => {
                            if (processesFromUrl.includes(item.id)) {
                                if (item.status !== "NOT_PUBLISHED" && !item.archived) {
                                    this.selectedProcesses.push(item.id);
                                } else if (item.archived) {
                                    this.selectedArchivedProcesses.push(item.id);
                                }
                            }
                        });
                    }
                });
            }
            if (query.dataModelFields) {
                const parsedDataModel = JSON.parse(decodeURIComponent(query.dataModelFields));
                this.dataModelList = parsedDataModel;
                this.dataModelList.filter(obj => obj.selected).forEach(obj => this.dataModel.push(obj));
            }
            if (query.startDateFrom && query.startDateTo) {
                this.fromStartDate = new Date(query.startDateFrom).toISOString();
                this.toStartDate = new Date(query.startDateTo).toISOString();
            }
            if (query.lastUpdateDateFrom && query.lastUpdateDateTo) {
                this.fromLastUpdate = new Date(query.lastUpdateDateFrom).toISOString();
                this.toLastUpdate = new Date(query.lastUpdateDateTo).toISOString();
            }
            if (query.initiatorUserIds) {
                this.initiatorUserFromUrlToShow = true;
                this.initiatorCheck = query.initiatorUserIds.split(",");
            }
            ["searchApp", "searchTerm", "searchValueUserList", "searchValueGroupMembers"].forEach(key => {
                if (query[key]) this[key] = query[key];
                if (key === "searchApp") {
                    this.displayAppList();
                }
            });
            const assigneeGroupIds = query.assigneeGroupIds?.split(",");
            const assigneeUserIds = query.assigneeUserIds?.split(",");

            this.assigneeMembers = (assigneeGroupIds || []).concat(assigneeUserIds || []);
            this.hasAssigneesSelected = this.assigneeMembers.length > 0;
        }

        this.objToSend = {
            page: query.page ? Number(query.page - 1) : 0,
            searchTerm: query.searchTerm ? this.searchTerm : "",
            size: query.size ? query.size : 10,
            sortDirection: this.objFromQueryURL.sortDirection && this.objFromQueryURL.sortDirection !== "DESC"
                ? this.objFromQueryURL.sortDirection : "DESC",
            sortField: this.objFromQueryURL.sortField && this.objFromQueryURL.sortField !== "modifiedOn"
                ? this.objFromQueryURL.sortField : "modifiedOn",
            applicationIds: query.applicationIds ? [...this.objFromQueryURL.applicationIds] : [],
            processDefinitionIds: query.processDefinitionIds ? [...this.objFromQueryURL.processDefinitionIds] : [],
            systemStatuses: query.systemStatuses ? [...this.objFromQueryURL.systemStatuses] : [],
            dataModelFields: query.dataModelFields ? this.dataModel : [],
            startDateFrom: query.startDateFrom ? this.formatTimeToSend(this.fromStartDate) : "",
            startDateTo: query.startDateTo ? this.formatTimeToSend(this.toStartDate) : "",
            lastUpdateDateFrom: query.lastUpdateDateFrom ? this.formatTimeToSend(this.fromLastUpdate) : "",
            lastUpdateDateTo: query.lastUpdateDateTo ? this.formatTimeToSend(this.toLastUpdate) : "",
            initiatorUserIds: query.initiatorUserIds ? this.initiatorCheck : [],
            assigneeUserIds: query.assigneeUserIds ? query.assigneeUserIds.split(",") : [],
            assigneeGroupIds: query.assigneeGroupIds ? query.assigneeGroupIds.split(",") : []
        };
        if (this.mode === "a" && !this.mountedApplyFilter) {
            if (query.systemStatuses) {
                this.objToSend.systemStatuses = this.objFromQueryURL.systemStatuses;
                this.systemStatus = query.systemStatuses.split(",");
            } else if (query && Object.keys(query).length && !query.systemStatuses) {
                this.objToSend.systemStatuses = [];
                this.systemStatus = [];
            } else {
                this.objToSend.systemStatuses = ["FAILED"];
                this.systemStatus = ["FAILED"];
            }
            if (this.objFromQueryURL.systemStatuses && this.objFromQueryURL.systemStatuses.length === 5) {
                this.systemStatus.push("ALL_STS");
            }
            this.$emit("applyFilterPayload", this.objToSend);
        } else if (this.mode === "b") {
            this.objToSend.systemStatuses = query.systemStatuses ? this.objFromQueryURL.systemStatuses : ["COMPLETED"];
        }
        this.mountedApplyFilter = false;
        this.nrOfTotalFilters();
    },
    deactivated() {
        this.deactivatedTriggered = true;
        this.mountedApplyFilter = false;
        this.clearAll();
    },
    methods: {
        ...mapMutations("main", ["setCurrentApplicationId"]),
        ...mapActions("apps", ["getAllApps", "getAppsNumber", "getPagedApps", "getAppProcessesPI"]),
        ...mapActions("admin", ["searchProcesses"]),
        optionsToStartDate(data) {
            return this.filterDays(data, this.fromStartDate);
        },
        optionsToLastDate(data) {
            return this.filterDays(data, this.fromLastUpdate);
        },
        checkDate(date1, date2) {
            const newDate1 = new Date(date1);
            const newDate2 = new Date(date2);
            const diffDays = date.getDateDiff(newDate1, newDate2, "minutes");

            return diffDays > 0;
        },
        filterDays(data, minDate) {
            let valid = true;
            if (minDate) {
                const newDate = date.formatDate(minDate, APP_DATE_SLASH);
                valid = data >= newDate;
            }
            return valid;
        },
        applyFiltersBtn() {
            this.applyFilter();
            this.$emit("searchValues", this.searchAction);
            this.$emit("input", false);
        },
        archivedProcessToggle() {
            if (this.archivedProcess) {
                this.getAppProcessesPI({ appId: this.selectedApp[0], archived: true }).then(rsp => {
                    if (rsp.data) {
                        this.archivedProcessList = [];
                        rsp.data.forEach(item => {
                            if (item.archived) {
                                this.archivedProcessList.push({ label: item.name, value: item.id });
                            }
                        });
                    }
                });
            }
        },
        appListScrollBehavior(searchText) {
            const trimmedText = searchText ? searchText.trim() : "";
            if (trimmedText) {
                if (trimmedText.length >= 3) {
                    this.searchApps(trimmedText);
                }
            } else {
                this.searchApps(trimmedText);
            }
        },
        searchApps(searchText) {
            this.searchTrigger = false;
            this.pagedAppsObject.search = searchText;
            this.pagedAppsObject.page = 0;
            this.pagedAppsObject.ids = [];
            this.pagedAppsObject.archived = this.archivedApp;
            if (!this.pagedAppsObjectCopy || (JSON.stringify(this.pagedAppsObjectCopy) !== JSON.stringify(this.pagedAppsObject))) {
                this.$store.commit("apps/resetPagedApps");
                this.getPagedApps(this.pagedAppsObject).then(() => {
                    this.searchTrigger = true;
                    if (this.$refs.appListContainer) {
                        if (this.$refs.appListContainer.$el.offsetHeight < 450) {
                            this.$refs.appListContainer.$el.style.overflow = "hidden";
                        } else {
                            this.$refs.appListContainer.$el.style.overflow = "auto";
                        }
                    }
                });
                this.pagedAppsObjectCopy = { ...this.pagedAppsObject };
            }
        },
        valueType(data) {
            let valueToBeDisplayed = "";
            if (data.fieldType === "DATE") {
                valueToBeDisplayed = date.formatDate(data.statementInput, APP_DATE_SLASH);
            } else if (data.fieldType === "DATETIME") {
                valueToBeDisplayed = date.formatDate(data.statementInput, APP_DATETIME_SLASH);
            } else if (data.fieldType === "TIME") {
                valueToBeDisplayed = formatDateAndTime(data.fieldType.toLowerCase(), data.statementInput, true);
            } else {
                valueToBeDisplayed = data.value;
            }
            return valueToBeDisplayed;
        },
        setConditionSign(operator) {
            let sign = "=";
            switch (operator) {
                case "EQUAL":
                    sign = "=";
                    break;
                case "NOT_EQUAL":
                    sign = "!=";
                    break;
                case "CONTAINS":
                    sign = "⊂";
                    break;
                case "GREATER_THAN":
                    sign = ">";
                    break;
                case "GREATER_THAN_OR_EQUAL":
                    sign = ">=";
                    break;
                case "LOWER_THAN":
                    sign = "<";
                    break;
                case "LOWER_THAN_OR_EQUAL":
                    sign = "<=";
                    break;
                default:
            }
            return sign;
        },
        showClearIconFunc(value, state) {
            if (state === "fromStartDate") {
                this.showClearIconFromStart = !!value;
            }
            if (state === "toStartDate") {
                this.showClearIconToStart = !!value;
            }
            if (state === "fromLastUpdate") {
                this.showClearIconFromLast = !!value;
            }
            if (state === "toLastUpdate") {
                this.showClearIconToLast = !!value;
            }
            this.nrOfTotalFilters();
        },
        selectTab(value) {
            if (this.selectTab !== value) {
                this.searchRoleUsers = "";
            }
        },
        updateDate() {
            if (this.fromStartDate && this.toStartDate) {
                this.noFromStartDateFound = false;
                this.noToStartDateFound = false;
                this.nrOfTotalFilters();
            }

            if (this.fromLastUpdate && this.toLastUpdate) {
                this.noFromLastUpdateFound = false;
                this.noToLastUpdateFound = false;
                this.nrOfTotalFilters();
            }
        },
        updateModel(isFromStart, isStartDate, isFromLast, isLastUpdate) {
            if (isFromStart && isStartDate) {
                this.fromStartDate = "";
                if (!this.toStartDate) {
                    this.noToStartDateFound = false;
                } else {
                    this.noFromStartDateFound = true;
                    this.noToStartDateFound = false;
                }
            } else if (!isFromStart && isStartDate) {
                this.toStartDate = "";
                if (!this.fromStartDate) {
                    this.noFromStartDateFound = false;
                } else {
                    this.noFromStartDateFound = false;
                    this.noToStartDateFound = true;
                }
            } else if (isFromLast && isLastUpdate) {
                this.fromLastUpdate = "";
                if (!this.toLastUpdate) {
                    this.noToLastUpdateFound = false;
                } else {
                    this.noFromLastUpdateFound = true;
                    this.noToLastUpdateFound = false;
                }
            } else if (!isFromLast && isLastUpdate) {
                this.toLastUpdate = "";
                if (!this.fromLastUpdate) {
                    this.noFromLastUpdateFound = false;
                } else {
                    this.noFromLastUpdateFound = false;
                    this.noToLastUpdateFound = true;
                }
            }
        },
        editDataModelFunc(data, index) {
            this.addDataModelModal = true;
            this.editDataModel = data;
            this.isInEditMode = true;
            this.editDataModelIndex = index;
            this.$emit("modalClosed", false);
            for (let i = 0; i < this.dataModel.length; i++) {
                if (this.dataModel[i] === data) {
                    this.indexDataModel = i;
                    break;
                }
            }
        },
        deleteDataModel(index) {
            for (let i = 0; i < this.dataModel.length; i++) {
                if (this.dataModelList[index] === this.dataModel[i]) {
                    this.dataModel.splice(i, 1);
                    break;
                }
            }
            this.dataModelList.splice(index, 1);
            this.nrOfTotalFilters();
        },
        openOrCloseAppList() {
            if (this.openOrCloseCollaps[0].icon === "mdi-chevron-down") {
                this.showAppList = true;
                this.openOrCloseCollaps[0].icon = "mdi-chevron-up";
            } else {
                this.showAppList = false;
                this.openOrCloseCollaps[0].icon = "mdi-chevron-down";
            }
        },
        getApps(scroll) {
            if (scroll.direction === "down" && scroll.position > 0 && this.pagedAppsObject.page <= this.allAppsNumber / 18) {
                this.pagedAppsObject.page++;
                this.searchTrigger = false;
                if (this.getStaticAppIdsList.length > 0) {
                    this.pagedAppsObject.ids = this.getStaticAppIdsList;
                }
            }
            if (!this.firstLoadApps && (!this.pagedAppsObjectCopy
            || (JSON.stringify(this.pagedAppsObjectCopy) !== JSON.stringify(this.pagedAppsObject))) && !this.searchTrigger) {
                this.getPagedApps(this.pagedAppsObject);
                this.pagedAppsObjectCopy = { ...this.pagedAppsObject };
            } else if (this.firstLoadApps) {
                this.firstLoadApps = false;
            }
        },
        uncheckApp(index, val) {
            for (let i = 0; i < this.appsSelectedArray.length; i++) {
                if (this.appsSelectedArray[i].value === val) {
                    this.appsSelectedArray.splice(i, 1);
                    break;
                }
            }
            this.selectedApp.splice(index, 1);
            if (this.appsSelectedArray.length === 1) {
                this.checkboxDisabled = false;
            }
        },
        openDataModelModal() {
            if (this.selectedApp.length === 1 || this.mode === "b") {
                this.addDataModelModal = true;
                this.isInEditMode = false;
            } else {
                this.addDataModelModal = false;
                this.isDisabled = true;
            }
        },
        selectApp(selectedApp) {
            this.appsSelectedArray = [];
            this.processList = [];
            this.archivedProcessList = [];
            this.selectedProcesses = [];
            this.selectedArchivedProcesses = [];
            if (selectedApp.length < this.selectedAppsDetails.length) {
                this.selectedAppsDetails = this.selectedAppsDetails.filter(item => selectedApp.includes(item.id));
            } else {
                const { id, archiveStatus } = this.pagedApps.find(app => app.id === selectedApp[selectedApp.length - 1]) || {};
                this.selectedAppsDetails.push({ id, archiveStatus });
            }
            if (selectedApp.length === 1) {
                if (this.selectedAppsDetails[0].archiveStatus === "ARCHIVED") {
                    this.processToggleDisabled = true;
                    this.archivedProcess = true;
                } else {
                    this.processToggleDisabled = false;
                }
                this.checkboxDisabled = false;
                this.$store.commit(
                    "main/setCurrentApplicationId",
                    selectedApp[0]
                );
                this.$refs.dataModelColaps.show();
                this.getAppProcessesPI({ appId: selectedApp[0], archived: this.archivedProcess }).then(rsp => {
                    if (rsp.data) {
                        rsp.data.forEach(item => {
                            if (item.status !== "NOT_PUBLISHED" && !item.archived) {
                                this.processList.push({ label: item.name, value: item.id });
                            } else if (item.archived) {
                                this.archivedProcessList.push({ label: item.name, value: item.id });
                            }
                        });
                    }
                });
            } else {
                this.dataModel = [];
                this.checkboxDisabled = selectedApp.length > 1;
                this.dataModelList = [];
            }
            this.nrOfTotalFilters();
        },
        statusCheckboxChange(value) {
            if (value === "ALL_STS") {
                this.systemStatus = this.systemStatus.find(el => el === value)
                    ? [
                        "ALL_STS",
                        "RUNNING",
                        "COMPLETED",
                        "FAILED",
                        "TERMINATED",
                        "ARCHIVED"
                    ]
                    : [];
            } else if (
                this.systemStatus.length === this.dataSystemStatus.length - 1
                && (value === "RUNNING"
                    || value === "COMPLETED"
                    || value === "FAILED"
                    || value === "TERMINATED"
                     || value === "ARCHIVED")
            ) {
                const allStatuses = this.systemStatus.find(el => (el === "ALL_STS"));
                if (allStatuses) {
                    const index = this.systemStatus.indexOf("ALL_STS");
                    if (index !== -1) {
                        this.systemStatus.splice(index, 1);
                    }
                }
            }
            this.nrOfTotalFilters();
        },
        clearAll(event, resetFilters) {
            this.searchValueUserList = "";
            this.searchValueGroupMembers = "";
            this.assigneeMembers = [];
            this.systemStatus = resetFilters ? ["COMPLETED"] : [];
            this.dataModelList = [];
            this.searchApp = "";
            this.selectedApp = [];
            this.selectedAppsDetails = [];
            this.$store.commit("apps/resetPagedApps");
            this.pagedAppsObjectCopy = null;
            this.pagedAppsObject = {
                page: 0,
                search: "",
                ids: [],
                archived: false
            };
            this.fromStartDate = "";
            this.toStartDate = "";
            this.fromLastUpdate = "";
            this.toLastUpdate = "";
            this.userCheck = [];
            this.selectedProcesses = [];
            this.selectedArchivedProcesses = [];
            this.groupsCheck = [];
            this.initiatorCheck = [];
            this.$root.$emit("clearAllMembers");
            this.selectedValues = [];
            this.dataModel = [];
            this.nrOfTotalFilters();
            if (!resetFilters && event) {
                event.target.offsetParent.classList.remove("q-focusable");
            }
            this.deactivatedTriggered = false;
            if (!this.deactivatedTriggered && this.$route.query && Object.keys(this.$route.query).length) {
                const queryObject = {};
                Object.entries(this.objToSend).forEach(([key, value]) => {
                    if (typeof value === "string" && value !== "") {
                        queryObject[key] = value;
                    } else if (typeof value === "number") {
                        queryObject[key] = value === 0 ? value + 1 : value;
                    }
                });

                const queriesAreDifferent = JSON.stringify({ query: queryObject }) !== JSON.stringify(this.$route.query);
                if (queriesAreDifferent) {
                    this.$router.replace({ query: queryObject });
                }
            }
        },
        nrOfTotalFilters() {
            const startDate = this.fromStartDate && this.toStartDate ? 1 : 0;
            const lastUpdate = this.fromLastUpdate && this.toLastUpdate ? 1 : 0;
            this.nrOfFilters = this.systemStatus.length
                + this.selectedProcesses.length
                + this.selectedArchivedProcesses.length
                + this.selectedApp.length
                + this.selectedValues.length
                + this.initiatorCheck.length
                + this.dataModel.length
                + startDate
                + lastUpdate;

            const findAllStatuses = this.systemStatus.find(el => (el === "ALL_STS"));
            if (findAllStatuses) {
                this.nrOfFilters--;
            }
        },
        formatTimeToSend(data) {
            const dateObj = new Date(data);
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, "0");
            const day = String(dateObj.getDate()).padStart(2, "0");
            const hours = String(dateObj.getHours()).padStart(2, "0");
            const minutes = String(dateObj.getMinutes()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        makeObjectToSend(status, direction, rowsPerPage, pageSelected) {
            this.nrOfResults = 0;
            let finalSystemStatusArr = [];
            finalSystemStatusArr = this.systemStatus.slice(0);
            if (this.systemStatus && this.systemStatus.length === 6) {
                const index = finalSystemStatusArr.indexOf("ALL_STS");
                if (index !== -1) {
                    finalSystemStatusArr.splice(index, 1);
                }
            }
            let fromStDate = "";
            let toStDate = "";
            let fromLstUpdate = "";
            let toLstUpdate = "";
            if (this.fromStartDate && this.toStartDate) {
                fromStDate = this.formatTimeToSend(this.fromStartDate);
                toStDate = this.formatTimeToSend(this.toStartDate);
            }
            if (this.fromLastUpdate && this.toLastUpdate) {
                fromLstUpdate = this.formatTimeToSend(this.fromLastUpdate);
                toLstUpdate = this.formatTimeToSend(this.toLastUpdate);
            }
            this.objToSend = {
                page: (status || direction) && pageSelected ? pageSelected : 0,
                size: (status || direction) && rowsPerPage ? rowsPerPage : 10,
                sortDirection: direction || "DESC",
                sortField: status || this.sortField,
                applicationIds: this.mode === "a"
                    ? this.selectedApp
                    : this.currentApplicationsArray,
                processDefinitionIds: this.selectedProcesses.concat(this.selectedArchivedProcesses),
                searchTerm: this.searchTerm,
                systemStatuses: finalSystemStatusArr,
                assigneeGroupIds: this.groupsCheck,
                assigneeUserIds: this.userCheck,
                initiatorUserIds: this.initiatorCheck,
                startDateFrom: fromStDate,
                startDateTo: toStDate,
                lastUpdateDateFrom: fromLstUpdate,
                lastUpdateDateTo: toLstUpdate,
                dataModelFields: this.dataModel
            };
            this.$emit("applyFilterPayload", this.objToSend);

            if (this.$route.name === "processInspector") {
                const query = {};
                Object.entries({ ...this.objToSend }).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        if (value.length > 0 || (key === "dataModelFields" && this.dataModelList.length)) {
                            if (value.every(item => typeof item === "object" && item !== null && !Array.isArray(item))) {
                                if (key === "dataModelFields") {
                                    value = this.dataModelList.map(item => ({
                                        ...item,
                                        selected: value.some(data => item.fieldName === data.fieldName
                                            && item.operator === data.operator
                                            && item.value === data.value
                                            && item.fieldType === data.fieldType)
                                    }));
                                }
                                query[key] = encodeURIComponent(JSON.stringify(value));
                            } else {
                                query[key] = value.join(",");
                            }
                        }
                    } else if (value || value === 0) {
                        query[key] = value;
                    }
                });

                ["searchApp", "searchValueUserList", "searchValueGroupMembers"].forEach(key => {
                    if (this[key]) query[key] = this[key];
                });
                query.archivedApp = this.archivedApp;
                query.archivedProcesses = this.archivedProcess;
                if (query.page === 0) {
                    query.page = 1;
                }

                const { path, fullPath } = this.$route;
                const checkMatchRoute = this.$router.match({ path, query });
                if (fullPath !== checkMatchRoute.fullPath) {
                    this.$router.replace({ query });
                }
            }
        },
        applyFilter(status, direction, rowsPerPage, pageSelected) {
            if (this.fromStartDate && !this.toStartDate) {
                this.noToStartDateFound = true;
            } else if (!this.fromStartDate && this.toStartDate) {
                this.noFromStartDateFound = true;
            } else if (!this.fromLastUpdate && this.toLastUpdate) {
                this.noFromLastUpdateFound = true;
            } else if (this.fromLastUpdate && !this.toLastUpdate) {
                this.noToLastUpdateFound = true;
            } else if (!(this.toStartIsBigger || this.toLastIsBigger)) {
                this.makeObjectToSend(status, direction, rowsPerPage, pageSelected);
            }
        },
        displayAppList() {
            if (!this.showAppList) {
                this.showAppList = true;
                this.openOrCloseCollaps[0].icon = "mdi-chevron-up";
            }
            this.appListScrollBehavior(this.searchApp);
        },
        badgeType(type) {
            const typeToReturn = (type === "NUMBER") ? "INTEGER" : type;
            return typeToReturn;
        },
        handleSearchValueUserList(searchValue) {
            this.searchValueUserList = searchValue;
        },
        handleSearchValueGroupMembers(searchValue) {
            this.searchValueGroupMembers = searchValue;
        },
        clearAssigneesSelected() {
            this.assigneeMembers = [];
        }
    }
};
